import { createAction, props } from '@ngrx/store';

import {
  Wallet,
  WalletWhitelistAddressesQuery,
  WalletWhitelistAddressesResponse,
} from '../../models/wallet.model';

// Wallet Whitelist Addresses Actions
export const loadWalletWhitelistAddresses = createAction(
  '[Wallet] Load Wallet Whitelist Addresses',
  props<{ walletId: string; query: WalletWhitelistAddressesQuery }>()
);

export const loadWalletWhitelistAddressesSuccess = createAction(
  '[Wallet] Load Wallet Whitelist Addresses Success',
  props<{ response: WalletWhitelistAddressesResponse }>()
);

export const loadWalletWhitelistAddressesFailure = createAction(
  '[Wallet] Load Wallet Whitelist Addresses Failure',
  props<{ error: string }>()
);

export const loadWalletDetails = createAction(
  '[Wallet] Load Wallet Details',
  props<{
    walletId: string;
    addresses: boolean;
    settings: boolean;
    assetNetwork: boolean;
    vault: boolean;
  }>()
);

export const loadWalletDetailsSuccess = createAction(
  '[Wallet] Load Wallet Details Success',
  props<{ data: Wallet }>()
);

export const loadWalletDetailsFailure = createAction(
  '[Wallet] Load Wallet Details Failure',
  props<{ error: string }>()
);
